var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 5.10457 20.1046 6 19 6C17.8954 6 17 5.10457 17 4C17 2.89543 17.8954 2 19 2C20.1046 2 21 2.89543 21 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5086 4.24731C12.809 4.91526 11.0502 6.18297 9.90412 7.59721C8.19125 9.71084 7.75002 12.271 7.75 13.9999C7.74994 14.414 7.41417 14.7499 7 14.7499C6.58579 14.7499 6.25 14.4141 6.25 13.9999C6.25 13.0916 6.35707 11.9633 6.67691 10.7664C3.86698 11.6515 2 13.2167 2 14.9999C2 17.7613 6.47715 19.9999 12 19.9999C17.5228 19.9999 22 17.7613 22 14.9999C22 13.2636 20.23 11.734 17.5429 10.8376C17.2275 12.108 17.0357 13.2448 17.0357 13.9999C17.0357 14.4141 16.6999 14.7499 16.2857 14.7499C15.8715 14.7499 15.5358 14.414 15.5357 13.9999C15.5357 12.4963 16.1275 10.0159 16.8744 7.78104C16.9651 7.50964 17.0587 7.24006 17.1545 6.97437C16.227 6.39771 15.5891 5.39935 15.5086 4.24731Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat4);
export default __webpack_public_path__ + "static/media/hat-4.ed386c5a10dd43ff98ed82da6b427d5e.svg";
export { ForwardRef as ReactComponent };